// extracted by mini-css-extract-plugin
export default {"content_wrapper":"ui_content_wrapper__2hqD5","buttons":"ui_buttons__chod5"};